import YesNoSecurity from "@/enumerations/Security/YesNoSecurity";
import SecuritySettingsBase from "./SecuritySettingsBase";

export default class PurchasesSecuritySettings extends SecuritySettingsBase {
  private static instance: PurchasesSecuritySettings;

  private constructor() {
    super();
  }

  public static getInstance(): PurchasesSecuritySettings {
    if (!PurchasesSecuritySettings.instance) {
      PurchasesSecuritySettings.instance = new PurchasesSecuritySettings();
    }

    return PurchasesSecuritySettings.instance;
  }

  private get showPurchases(): boolean {
    return (
      !this.isManagerAccountSelected &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.purchases,
        YesNoSecurity.yes
      )
    );
  }

  public get showPurchasesMenu(): boolean {
    return (
      this.showPurchases &&
      (this.showViewCreditActivityPage ||
        this.showViewPurchasesPage ||
        this.showViewTransactionsPage ||
        this.showViewStatementsPage ||
        this.showViewPurchaseSummaryPage ||
        this.showViewFuelPurchaseSummaryPage ||
        this.showViewUpcomingDeliveriesPage)
    );
  }

  public get showViewFuelPurchaseSummaryPage(): boolean {
    return (
      this.parameters.showFuelPurchaseSummary &&
      this.showPurchases &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewFuelPurchaseSummary,
        YesNoSecurity.yes
      )
    );
  }

  public get showViewUpcomingDeliveriesPage(): boolean {
    return (
      this.parameters.showUpcomingDeliveries &&
      this.showPurchases &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewUpcomingDeliveries,
        YesNoSecurity.yes
      )
    );
  }

  public get showViewCreditActivityPage(): boolean {
    return (
      this.parameters.showCreditActivity &&
      this.showPurchases &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewCreditActivity,
        YesNoSecurity.yes
      )
    );
  }

  public get showViewPurchasesPage(): boolean {
    return (
      this.parameters.showPurchases &&
      this.showPurchases &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewPurchases,
        YesNoSecurity.yes
      )
    );
  }

  public get showViewTransactionsPage(): boolean {
    return (
      this.parameters.showItemsPurchased &&
      this.showPurchases &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewPurchaseTransactions,
        YesNoSecurity.yes
      )
    );
  }

  public get showViewStatementsPage(): boolean {
    return (
      this.parameters.showStatementsMenu &&
      this.showPurchases &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewStatements,
        YesNoSecurity.yes
      )
    );
  }

  public get showViewPurchaseSummaryPage(): boolean {
    return (
      this.parameters.showPurchaseSummary &&
      this.showPurchases &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewPurchaseSummary,
        YesNoSecurity.yes
      )
    );
  }

  /**
   * Whether one purchase can be read on its own, which is what a detail card opened from another page fetches.
   * The read is guarded by the Purchases rights rather than by the rights of the page the card was opened from,
   * so this repeats the API's own line: Purchases with either Purchases or Credit Activity, or Orders with
   * Orders. A profile granted only Upcoming Deliveries has none of those, and the refusal comes back as a plain
   * failure, so the card is not offered rather than offered and then refused.
   */
  public get canViewOnePurchase(): boolean {
    const canViewUnderPurchases =
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.purchases,
        YesNoSecurity.yes
      ) &&
      (this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewPurchases,
        YesNoSecurity.yes
      ) ||
        this.checkUserProfileBasedSecurity(
          this.userProfileBasedSecurity.viewCreditActivity,
          YesNoSecurity.yes
        ));

    const canViewUnderOrders =
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.orders,
        YesNoSecurity.yes
      ) &&
      this.checkUserProfileBasedSecurity(
        this.userProfileBasedSecurity.viewOrders,
        YesNoSecurity.yes
      );

    return canViewUnderPurchases || canViewUnderOrders;
  }
}
